import { alpha, Box, MenuItem } from "@mui/material"
import Label from "minimals-template/components/Label"
import Iconify from "minimals-template/components/Iconify"
import { SCHEDULE } from "library/constants.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { Else, If } from "lib/@components/switch"
import { cleanLabel } from "routes/regime/plugins/regime-search/lib/search-labels.mjs"
import { iconForResult } from "routes/regime/plugins/regime-search/lib/search-icons.js"
import { scopeOf } from "routes/regime/plugins/regime-search/lib/search-scopes.js"

const SCOPE_TYPE_NAMES = { regime: "Maintenance Regime", facility: "Facility", floor: "Floor", space: "Space" }
const TYPE_NAMES = { system: "System", group: "Group", folder: "Folder" }

export function RegimeSearchResult({ props, item }) {
    const thumbnail = getThumbnail()
    const label = getLabel()
    const subtitle = getSubtitle()
    const badge = getBadge()

    return (
        <MenuItem {...props} data-cy="regime-search-result">
            <If value={!!thumbnail}>
                <Box
                    component="img"
                    data-cy="regime-search-result-thumbnail"
                    src={thumbnail}
                    alt={label}
                    loading="lazy"
                    sx={{ width: 32, height: 32, borderRadius: 1, objectFit: "cover", mr: 1, flexShrink: 0 }}
                />
                <Else>
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: 1,
                            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                            color: "primary.main",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1,
                            flexShrink: 0,
                        }}
                    >
                        <Iconify icon={iconForResult(item)} sx={{ width: 20, height: 20 }} />
                    </Box>
                </Else>
            </If>
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <TruncatedTypography>{label}</TruncatedTypography>
                <If value={!!subtitle}>
                    <TruncatedTypography variant="caption" sx={{ color: "text.secondary" }}>
                        {subtitle}
                    </TruncatedTypography>
                </If>
            </Box>
            <If value={!!badge}>
                <Label data-cy="regime-search-result-badge" color={badgeColor()} sx={{ ml: 1, flexShrink: 0 }}>
                    {badge}
                </Label>
            </If>
        </MenuItem>
    )

    function getLabel() {
        if (item.isAsset) return item.label
        return cleanLabel(item.label ?? item.data?.name)
    }

    function getSubtitle() {
        if (item.isAsset) {
            if (item.count > 1) return `${item.count} Assets`
            return assetSubtitle()
        }
        if (item.type === SCHEDULE) return item.code ? `#${item.code}` : ""
        return typeName()
    }

    function assetSubtitle() {
        const parts = []
        if (item.tag && item.tag !== item.label) parts.push(item.tag)
        if (item.scheduleTitle) parts.push(item.scheduleTitle)
        return parts.join(" - ")
    }

    function typeName() {
        return SCOPE_TYPE_NAMES[scopeOf(item)] ?? TYPE_NAMES[item.data?.subType] ?? "Folder"
    }

    function getBadge() {
        if (item.isAsset) return "Asset"
        if (item.type === SCHEDULE) return "Schedule"
        return null
    }

    function badgeColor() {
        if (item.isAsset) return "info"
        return "default"
    }

    function getThumbnail() {
        if (!item[PlanRoot]) return null
        return item.$?.images?.find(Boolean) ?? null
    }
}
